import script from "./AppAccountRail.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAccountRail.vue?vue&type=script&setup=true&lang=js"

import "./AppAccountRail.vue?vue&type=style&index=0&id=348d48cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348d48cc"]])

export default __exports__